import { Model } from "pinia-orm";

export default class Polygon extends Model {
  static entity = "polygons";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      coordinates: this.attr([]),
    };
  }
}
